import type { orderItem } from 'src/shared/frontendTypes/warenkorb'
import { isQuantityDiscountAvailable } from 'src/shared/discountShop'
import { getQuantityDiscountText } from 'src/functions/quantityDiscountText'
import { getCartLinePrice } from 'src/functions/cartPriceLock'

export type CartQuantityDiscountInfo = {
  key: string
  name: string
  title: string
  progress: string
}

const hasAppliedQuantityDiscount = (item: orderItem) => {
  const { price, qty, onlyStock, stock } = item
  if (typeof price === 'number') return false
  if (price.showPercent === false) return false

  if (!isQuantityDiscountAvailable(price.quantityDiscount, {
    onlyStock,
    stock,
    dateEnd: price.dateEnd,
  })) return false

  const regularQuantityLinePrice = getCartLinePrice(price, qty, {
    onlyStock,
    stock,
    ignoreQuantityDiscount: true,
  })
  const quantityDiscountLinePrice = getCartLinePrice(price, qty, {
    onlyStock,
    stock,
  })

  return quantityDiscountLinePrice < regularQuantityLinePrice - 0.005
}

export const getCartQuantityDiscountInfos = (
  items: Record<string, orderItem>,
): CartQuantityDiscountInfo[] => (
  Object.values(items)
    .map(item => {
      if (!hasAppliedQuantityDiscount(item)) return null
      if (typeof item.price === 'number') return null

      const text = getQuantityDiscountText(item.price.quantityDiscount, item.qty)
      if (!text?.active || !text.progress) return null

      return {
        key: item.key,
        name: item.name,
        title: text.title,
        progress: text.progress,
      }
    })
    .filter((item): item is CartQuantityDiscountInfo => Boolean(item))
)
